import styled from "styled-components";

type ActiveProp = {
  $active?:boolean;
  $isArrow?:boolean;
  disabled?:boolean;
}

export const Container = styled.nav`
  display: flex;
  gap: 5px;
  position: relative;
  max-width: 100%;
  overflow-x: auto;
  /* width: 100%; */
`
export const ItemWrapper = styled.div`
  position: relative;
`
export const PaginationItem = styled.button<ActiveProp>`
  appearance: none;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 6px;
  width: ${({$isArrow}) => $isArrow ? '30px' : 'auto'};
  min-width: 30px;
  height: 30px;
  font: inherit;
  color:${({theme, $active}) => $active ? theme.isDark ? theme.base.black : theme.accent[100] : theme.base.black};
  border: ${({theme, disabled, $isArrow}) => $isArrow ? `1px solid ${disabled ? theme.grey[300] : theme.grey[400]}` : 'none'};
  border-radius: ${({theme}) => theme.radius.control};
  box-shadow: ${({theme, $isArrow, disabled}) => $isArrow && !disabled ? theme.shadows.control : ''};
  background: ${({theme, $active}) => $active ? theme.isDark ? theme.accent[100] : theme.accent[15] : theme.palette[10]};
  &:not(:disabled):hover{
    opacity:0.9;
    background-color:${({theme}) => theme.isDark ? '' : theme.primary[25]};
    cursor: pointer;
  }
  &:not(:disabled):active,
  &:focus-visible{
    border: ${({theme}) => `1px solid ${theme.accent[100]}`};
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
    outline: none;
  }
  &:disabled {
    cursor: default;
    img {
      opacity: ${({$isArrow}) => $isArrow ? '0.3' : '1'};
    }
  }

  @media (max-width: 480px) and (pointer: coarse) {
    width: 44px;
    height: 44px;
  }
`
export const SelectPageContainer = styled.form<ActiveProp>`
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  width: 217px;
  height: 56px;
  top: -69px;
  left: -245%;
  display: ${({$active}) => $active ? 'flex' : 'none'};
  position: absolute;
  background: ${({theme}) => theme.palette[10]};
  box-shadow: ${({theme}) => theme.shadows.menu};
  border-radius: ${({theme}) => theme.radius.control};
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
`

export const Rect = styled.div`
  width: 10px;
  height: 10px;
  top:51px;
  right: 50%;
  position: absolute;
  transform: rotate(45deg);
  z-index: 2;
  background: ${({theme}) => theme.palette[10]};
`

export const SelectPageInput = styled.input`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 12px 10px;
  width: 80px;
  height: 40px;
  margin-right: 10px;
  outline: none;
  background: ${({theme}) => theme.base.white};
  border: ${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius: ${({theme}) => theme.radius.control};
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
  }
`
